(() => {
  /** @type {HTMLElement | null} */
  const countdownElement = document.querySelector("[data-password-countdown]");
  /** @type {HTMLElement | null} */
  const configElement = document.querySelector("#password-page-config");
  /** @type {HTMLAnchorElement | null} */
  const signupButtonElement = document.querySelector("#password-signup-button");

  if (!countdownElement) {
    return;
  }

  if (configElement?.dataset.showCountdown === "false") {
    countdownElement.style.display = "none";
    return;
  }

  const configuredDays = Number.parseInt(
    configElement?.dataset.countdownDays ||
      countdownElement.dataset.countdownDays ||
      "7",
    10
  );
  const countdownDays =
    Number.isFinite(configuredDays) && configuredDays > 0 ? configuredDays : 7;
  const configuredTarget = configElement?.dataset.countdownTarget || "";
  const parsedTargetTimestamp = configuredTarget
    ? Date.parse(configuredTarget)
    : Number.NaN;
  const targetTimestamp = Number.isFinite(parsedTargetTimestamp)
    ? parsedTargetTimestamp
    : Date.now() + countdownDays * 24 * 60 * 60 * 1000;

  if (signupButtonElement) {
    const configuredLabel = (configElement?.dataset.signupLabel || "").trim();
    const configuredLink = (configElement?.dataset.signupLink || "").trim();

    if (configuredLabel) {
      signupButtonElement.textContent = configuredLabel;
    }

    if (configuredLink) {
      signupButtonElement.href = configuredLink;
    }
  }

  /** @param {number} value */
  const formatTwoDigits = (value) => String(value).padStart(2, "0");

  const render = () => {
    const remainingMs = Math.max(targetTimestamp - Date.now(), 0);

    const days = Math.floor(remainingMs / (24 * 60 * 60 * 1000));
    const hours = Math.floor(
      (remainingMs % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000)
    );
    const minutes = Math.floor((remainingMs % (60 * 60 * 1000)) / (60 * 1000));
    const seconds = Math.floor((remainingMs % (60 * 1000)) / 1000);
    const centiseconds = Math.floor((remainingMs % 1000) / 10);

    countdownElement.textContent = [
      formatTwoDigits(days),
      formatTwoDigits(hours),
      formatTwoDigits(minutes),
      formatTwoDigits(seconds),
      formatTwoDigits(centiseconds),
    ].join(":");
  };

  render();
  window.setInterval(render, 10);
})();
